module.exports = __webpack_public_path__ + "img/push-pin.269fbe27.svg";